import { Field } from '@kanda-libs/ks-component-ts';
import type { FunctionComponent } from 'react';
import { mapAprsToSelectOptions } from './helpers';

export interface RateMenuProps {
  aprs: number[];
  showBNPL?: boolean;
}

const RateMenu: FunctionComponent<RateMenuProps> = function ({
  aprs,
  showBNPL = false,
}) {
  return (
    <div>
      <Field.RadioSelect
        inline
        wrap
        variant="streamline-radio"
        name="apr"
        options={mapAprsToSelectOptions(aprs, showBNPL)}
      />
    </div>
  );
};

export default RateMenu;
